import React from 'react';
import clsx from 'clsx';
import { Accordion } from 'react-bootstrap';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import ContextAwareToggle from '@common/accordion/ContextAwareToggle';
import AccordionIcon from '@common/blocks/image/accordion-images/AccordionIcon';

import * as styles from '@styles/modules/block.module.scss';

const AccordionImages = ({ data }) => {
  const {
    title,
    showTitle,
    images
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) && <h2 className='mx-auto mb-4 col-lg-10 text-center'>{title}</h2>}
        <Accordion defaultActiveKey="0" className={`d-flex flex-column`}>
          <Row className={`position-relative flex-column-reverse`}>
            <div className={`col-lg-6`}>
              {images.map((image, index) => (
                <div className={clsx('mb-2 pt-1', styles.accordionBorder)} key={index}>
                  <ContextAwareToggle eventKey={`${index}`}>
                    {image.title}
                  </ContextAwareToggle>
                  <Accordion.Collapse eventKey={`${index}`}>
                    <div className={clsx('ms-2', styles.accordionText)}>
                      {image.description && <p>{image.description}</p>}
                    </div>
                  </Accordion.Collapse>
                </div>
              ))}
            </div>
            {images.map((image, index) => (
              <AccordionIcon
                key={index}
                eventKey={`${index}`}
                image={image.gatsbyImageData}
                file={image.file}
              />
            ))}
          </Row>
        </Accordion>
      </Container>
    </Section>
  )
}

export default AccordionImages
